module.exports = __webpack_public_path__ + "media/ringtones.0762ee44.mp3";